module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('nav', {
    staticClass: "thematicMenuBar button-group thematics",
    attrs: {
      "id": "navbar"
    },
    on: {
      "click": function($event) {
        _vm.isCategorySelected = true
      }
    }
  }, _vm._l((_vm.categories), function(category) {
    return _c('router-link', {
      directives: [{
        name: "scroll-to",
        rawName: "v-scroll-to",
        value: ('#navbar'),
        expression: "'#navbar'"
      }],
      key: category.id,
      class: {
        'abc': _vm.$route.params.category_code === category.code
      },
      attrs: {
        "to": '/' + category.code
      }
    }, [_vm._v("\n              " + _vm._s(category.name) + "\n            ")])
  }), 1), _vm._v(" "), _c('article', {
    attrs: {
      "id": "category"
    }
  }, [(!_vm.isCategorySelected) ? _c('div', {
    staticClass: "category-menu"
  }, [_c('carrousel', {
    on: {
      "navigate": _vm.navigate
    }
  })], 1) : _vm._e(), _vm._v(" "), _vm._m(0), _vm._v(" "), (!_vm.isCategorySelected) ? _c('h1', {
    attrs: {
      "id": "allVideo"
    }
  }, [_vm._v("Toutes nos vidéos")]) : _vm._e(), _vm._v(" "), (!_vm.isCategorySelected) ? _c('app-videos', {
    attrs: {
      "videos": _vm.videos
    }
  }) : _vm._e(), _vm._v(" "), _c('router-view')], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mobile-info-div"
  }, [_c('p', {
    staticStyle: {
      "margin": "auto"
    }
  }, [_c('strong', [_vm._v("Application mobile disponible, "), _c('a', {
    attrs: {
      "href": "/about#info-mobile",
      "target": "_blank"
    }
  }, [_vm._v("plus d'infos ici")]), _vm._v(" !")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9f55a69c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/CategoriesList.vue
// module id = 455
// module chunks = 1